import { Toolbar, Typography } from '@mui/material';
import { Trans } from '@lingui/react/macro';

const HistoryListHeader = () => {
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        component="div"
        data-testid="History-list-title"
      >
        <Trans>History</Trans>
      </Typography>
    </Toolbar>
  );
};

export default HistoryListHeader;
